/**
 * "This route's subject does not exist", as a throwable.
 *
 * Next's `notFound()` threw a framework signal that became a server 404. A
 * static bundle has no status code to set, so this throws a plain,
 * identifiable error and leaves rendering the "not found" state to whoever
 * catches it — in practice the page's `useApi` error path.
 */
export class NotFoundError extends Error {
  constructor(message = "not found") {
    super(message);
    this.name = "NotFoundError";
  }
}

export function notFound(): never {
  throw new NotFoundError();
}
